export default "__VITE_ASSET__CJlswjhN__"